@if (travels.length > 0) {
  <div class="flex flex-column align-items-center justify-content-center">
    <h2 class="text-center">
      Unisciti ai nostri gruppi in
      <span class="yellow">partenza</span>
      <img src="/assets/media/icons/airplane.png" width="30" />
    </h2>
    <span class="text-center grey-text mb-6"
      >Ogni mese organizziamo nuove esperienze da vivere insieme. Consulta i
      viaggi di gruppo in partenza, scegli la tua meta ideale e prenota in pochi
      click.</span
    >
  </div>
  <div class="grid">
    @for (t of travels; track $index) {
      <div class="col-12 lg:col-6 xl:col-3">
        <app-travel-card-minimal [travel]="t"></app-travel-card-minimal>
      </div>
    }
  </div>
  <div class="flex justify-content-end mt-5">
    <a routerLink="/viaggi-di-gruppo/departures" class="more">
      <span> Scopri tutti i gruppi in partenza </span>
      <i class="pi pi-arrow-circle-right"></i>
    </a>
  </div>
}
